import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_diaspora-care-hub/artifacts/o9fhoth9_WhatsApp%20Image%202026-06-20%20at%203.04.46%20PM.jpeg";

/**
 * Brand mark — presented in a soft, palette-matched frame while keeping the
 * logo artwork in its ORIGINAL colors (no blend modes, no crops, no filters).
 *
 * The soft frame integrates the sticker artwork with the peach/lavender page
 * palette; the artwork inside stays untouched.
 *
 * variants:
 *   - "compact" : header size (~68px tall) with peach→lavender halo ring
 *   - "stack"   : footer / about size (larger)
 *   - "hero"    : extra-large decorative watermark
 */
export default function BrandMark({ variant = "compact", className = "" }) {
  if (variant === "compact") {
    return (
      <span
        data-testid="brand-mark"
        className={`inline-flex items-center justify-center rounded-2xl relative ${className}`}
        style={{
          width: 76,
          height: 76,
          padding: 4,
          background:
            "linear-gradient(135deg, #FFE5D9 0%, #FBF5F0 50%, #E8DCF3 100%)",
          boxShadow:
            "0 4px 12px -4px rgba(139,123,181,0.35), inset 0 0 0 1px rgba(255,255,255,0.9)",
        }}
      >
        <img
          src={LOGO_URL}
          alt="Graceful Guidance — Grace is Sufficient"
          className="block rounded-xl"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
      </span>
    );
  }
  if (variant === "stack") {
    return (
      <span
        data-testid="brand-mark-stack"
        className={`inline-block rounded-3xl overflow-hidden ${className}`}
        style={{
          padding: 8,
          background:
            "linear-gradient(135deg, #FFE5D9 0%, #FBF5F0 50%, #E8DCF3 100%)",
          maxWidth: 280,
          boxShadow: "0 8px 24px -12px rgba(139,123,181,0.35)",
        }}
      >
        <img
          src={LOGO_URL}
          alt="Graceful Guidance — Grace is Sufficient"
          className="block rounded-2xl"
          style={{ width: "100%", height: "auto", objectFit: "contain" }}
          loading="lazy"
        />
      </span>
    );
  }
  return (
    <img
      data-testid="brand-mark-hero"
      src={LOGO_URL}
      alt="Graceful Guidance — Grace is Sufficient"
      className={`block ${className}`}
      style={{
        width: "100%",
        maxWidth: 420,
        height: "auto",
        objectFit: "contain",
      }}
      loading="lazy"
    />
  );
}
